import { render, staticRenderFns } from "./plus.vue?vue&type=template&id=d512da3e&scoped=true&"
import script from "./plus.vue?vue&type=script&lang=js&"
export * from "./plus.vue?vue&type=script&lang=js&"
import style0 from "./plus.vue?vue&type=style&index=0&id=d512da3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d512da3e",
  null
  
)

export default component.exports